export default {
  fire() {
    $('.form-search').on('submit', function (e) {
      e.preventDefault();

      let $this = $(this);
      let $submit = $this.find('[type=submit]');

      if ($submit.hasClass('disabled')) {
        return;
      }

      $submit.addClass('disabled');
      $submit.html($submit.text());

      $('.winner').remove();

      $.getJSON($this.attr('action'), { action: 'winners', lottery: $('#lottery').val() })
        .done(function (response) {
          if (response === '0') {
            $submit.removeClass('disabled');
            return;
          }

          let example = $('.example');

          for (let key in response) {
            let winner = response[key];
            let $clone = example.clone();

            $clone.removeClass('hidden-xs-up').removeClass('example').addClass('winner');

            if (winner.image) {
              $clone.find('img').attr('src', winner.image);
            } else {
              $clone.find('img').remove();
            }

            $clone.find('.title').text(winner.post_title);
            $clone.find('p').text(winner.post_excerpt);

            $('.winners').append($clone);
          }

          $submit.removeClass('disabled');
        });

      return false;
    });

    $('.form-search').trigger('submit');
  },
};



// WEBPACK FOOTER //
// ./scripts/components/winners.js